import React from "react";
import { ArrowRight, ExternalLink, Fuel, ChevronRight, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

export const HeroSection = ({ onBookClick, reviews = { rating: 4.8, user_ratings_total: 88, url: "" }, content }) => {
  const hero = content?.hero || {
    badge: "Performance & Précision",
    title_line_1: "AUVERGNE",
    title_line_2: "TECH RACING",
    subtitle: "Spécialiste Conversion Flexfuel E85 & Reprogrammation Moteur à Clermont-Ferrand. Roulez moins cher, roulez mieux.",
    cta_primary: "Prendre RDV",
  };
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_67cb5430-fb0d-4c25-a9f8-a4cee239dafe/artifacts/1co5d93h_IMG_0601.jpeg')`,
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#0A0A0A]" />
      <div className="carbon-texture absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <p className="text-sm font-bold tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
          {hero.badge}
        </p>
        <div role="doc-subtitle" aria-label="Auvergne Tech Racing" className="text-5xl sm:text-7xl md:text-8xl font-black tracking-tighter uppercase italic text-white mb-6 leading-none">
          {hero.title_line_1}
          <br />
          <span className="text-[#FF3B30]">{hero.title_line_2}</span>
        </div>
        <p className="text-base md:text-lg text-white/70 mb-10 max-w-xl mx-auto tracking-wide whitespace-pre-line">
          {hero.subtitle}
        </p>
        <button
          onClick={onBookClick}
          data-testid="hero-book-btn"
          className="inline-block bg-[#FF3B30] hover:bg-[#D63025] text-white font-bold uppercase tracking-wider px-10 py-4 transform skew-x-[-10deg] transition-all duration-300 hover:scale-105 shadow-[0_0_30px_rgba(255,59,48,0.4)]"
        >
          <span className="skew-content inline-block">{hero.cta_primary}</span>
        </button>
        <a
          href={reviews.url || "https://www.google.com/maps/search/Auvergne+Tech+Racing+Clermont-Ferrand"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-google-badge"
          className="mt-5 inline-flex items-center justify-center gap-2 text-white/90 text-sm hover:text-white transition-colors group cursor-pointer"
          aria-label="Voir nos avis Google"
        >
          <span className="text-yellow-400 text-base">★★★★★</span>
          <span className="font-semibold">{reviews.rating.toString().replace(".", ",")}/5</span>
          <span className="text-white/50 mx-1">—</span>
          <span className="underline-offset-4 group-hover:underline">{reviews.user_ratings_total} avis Google</span>
          <ExternalLink size={14} className="text-white/50 group-hover:text-white/90 transition-colors" />
        </a>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/50 animate-bounce">
        <ChevronDown size={32} />
      </div>
    </section>
  );
};

// ============== VEHICLE SELECTOR WIDGET ==============
